import { useContext } from 'react';
import { OccasionContext } from '@context';

export const useOccasionContext = () => {
  const context = useContext(OccasionContext);
  return context;
};
